// ----------------------------------------------------------------------

/**
 * Layer for the sidesheets mounted at the app root by `modal-container` — the mailer and the task
 * viewer. They are not children of whatever surface launched them, so they need a layer chosen
 * against MUI's scale rather than the surrounding component's.
 *
 * 1350 puts them above `zIndex.modal` (1300), which clears both the quick-view drawer
 * (`zIndex.drawer`, 1200) and the centred record overlay `Dialog` — before JT1-1583 the mailer sat
 * at 1000 and opened *behind* the quick view. It stays below `snackbar` (1400) and `tooltip` (1500)
 * so notifications and tooltips still surface over an open sidesheet.
 *
 * Anything raised to this layer must also carry `data-app-sidesheet`, which is how the record panel
 * knows to leave Esc and the arrow keys alone (see `record-panel-frame.tsx`).
 */
export const APP_SIDESHEET_Z_INDEX = 1350;
